import axios from "axios";
export default class OrderInvoiceService {
    loadInvoices(orderId) {
        return axios.get("/order/documents", {
            params: {
                orderId: orderId
            },
            withCredentials: true
        });
    }
    updateInvoice(orderId) {
        return axios.post('/order/invoice', null, {
            params: { orderId: orderId },
            withCredentials: true
        });
    }
    getInvoice(fileName) {
        return axios.get("/order/document", {
            params: {
                filename: fileName
            },
            responseType: 'blob',
            withCredentials: true
        });
    }
}
